import React, { useContext, useCallback, useState } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { useModal } from '@jutro/components';
import messages from './VehicleDetailsComponent.messages';
import styles from "../../../SpecialtyPersonalStyles.module.scss"
import metadata from './VehicleDetailsComponent.metadata.json5';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function VehicleDetailsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated,} = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('VehicleDetailsComponent');
    const modelVM = _.get(submissionVM, pathUpdated);
    const { showConfirm } = useModal();

    modelVM.value.isValidationReq = true;

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            if(changedPath === 'couFie') {
                 _.set(submissionVM, `${pathUpdated}.curFie`, value === 'Canada' ? 'CAD': 'USD')
            }

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    const deleteVehiclesDetails = useCallback(
        () => {
            const infoListPath = 'lobData.perLine.coverables.perUmbLiaCoverable.vehicleDetails.value';
            const info = modelVM.value;
            const infoList = _.get(submissionVM, infoListPath);

            showConfirm({
                title: messages.removeInfo,
                message: messages.removeInfoDesc,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.yes,
                cancelButtonText: messages.no
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }

                    const newinfoList = _.remove(infoList,
                        (infoFromList) => _.isEqual(infoFromList, info));

                    _.set(submissionVM, newinfoList, infoListPath);
                    updateWizardData(submissionVM);

                    return true;
                }, _.noop
            );
        }, [modelVM.value, submissionVM, showConfirm, updateWizardData]
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        useinanyracorspetetesFie: {
            defaultValue: false
        },
        makFie: {
            visible: _.get(modelVM.value, 'vehTypFie') !== 'Motorcycle' && _.get(modelVM.value, 'vehTypFie') !== 'Automobile'
        },
        makAutoMobileFie: {
            visible: !_.isUndefined(_.get(modelVM.value, 'vehTypFie')) && _.get(modelVM.value, 'vehTypFie') === 'Automobile'
        },
        makMotorcyleFie: {
            visible: !_.isUndefined(_.get(modelVM.value, 'vehTypFie')) && _.get(modelVM.value, 'vehTypFie') === 'Motorcycle'
        }        
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            deleteVehiclesDetails
        },
        resolveClassNameMap: styles
    };


    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

VehicleDetailsComponent.propTypes = wizardProps;
export default withRouter(VehicleDetailsComponent);
